// removed by extract-text-webpack-plugin
module.exports = {"section":"SubNavSection__section___ofCgO","link":"SubNavSection__link___1_oFQ","active":"SubNavSection__active___1_jNx SubNavSection__link___1_oFQ","icon":"SubNavSection__icon___1vSiD","label":"SubNavSection__label___1p0BS","label-hidden":"SubNavSection__label-hidden___208Pl SubNavSection__label___1p0BS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SubNavSection.scss
// module id = 521
// module chunks = 0